import TagManager from "react-gtm-module";
import { decrypt } from "./utils/others";

const userEmail = decrypt(localStorage.getItem("user"));

const GTM_ID = "GTM-TH4RWGG";


let isGtmInitialized = false;

const ensureGtmLoaded = () => {
  if (isGtmInitialized) return;
  TagManager.initialize({ gtmId: GTM_ID });
  isGtmInitialized = true;
};


const getMentorEmail = () => {
  try {
    const user = decrypt(localStorage.getItem("user"));
    return user?.user_name || "";
  } catch (_) {
    return "";
  }
};

/**
 * Fires one Epicenter GTM event.
 *
 * Wraps the EpicenterGTM payload shape so call sites don't repeat the
 * dataLayer/initialize pair, and carries event_label4 — EpicenterGTM stops at
 * label3, but the tracking sheet uses a fifth column.
 *
 * event/event_category are always "codeyoung_epicenter" and event_label is
 * always the mentor's email, so callers pass only the action and the extra
 * labels, in sheet order (event_label1 → label4).
 *
 * @param {string} action - event_action, e.g. "tutorials_clicked"
 * @param {Array<string|number>} [labels=[]] - event_label1 … event_label4
 */
export const fireEpicenterGtm = (action, labels = []) => {
  try {
    const [label1 = "", label2 = "", label3 = "", label4 = ""] = labels;
    ensureGtmLoaded();
    TagManager.dataLayer({
      dataLayer: {
        event: "codeyoung_epicenter",
        event_category: "codeyoung_epicenter",
        event_action: action,
        event_label: getMentorEmail(),
        event_label1: label1,
        event_label2: label2,
        event_label3: label3,
        event_label4: label4,
      },
    });
  } catch (_) {
    // Tracking must never break a mentor action.
  }
};

export const EpicenterGTM = (action, label1, label2, label3) => {
  return {
    gtmId: "GTM-TH4RWGG",
    dataLayer: {
      event: "codeyoung_epicenter",
      event_category: "codeyoung_epicenter",
      event_action: action,
      event_label: userEmail.user_name,
      event_label1: label1,
      event_label2: label2,
      event_label3: label3,
      // Cleared explicitly: the dataLayer is cumulative, so once any event sets
      // event_label4, GTM keeps attaching that value to later events that omit
      // it. Every sender must reset every label it does not use.
      event_label4: "",
    },
  };
};
